import request from '../request';
export function fetchApplication(id) {
    return request({
        url: '/prod-api/consumer/application/' + id,
        method: 'get',
    });
}
